import React, {Component} from 'react'
import {observer} from 'mobx-react'
import Chart from 'Components/_charts/singleTicker/Chart'
import {Spin} from 'antd'
import Progress from '../Progress'

import style from './tickerDetails.sass'
import PnlByTickerHeader from './PnlByTicker/Header'

@observer
class TickerDetails extends Component {
  componentDidMount() {
    this.props.store.getData()
  }
  render() {
    const {store} = this.props
    return(
      <div className='card'>
        {store.single.data.is_currently_running
          ? <Progress percent={store.completedPercentage}/>
          : <div>
            <div>
              <PnlByTickerHeader ticker={store.ticker}/>
              {store.metrics.map(record => {
                if (['vloatility', 'sharpe ratio', 'sortino ratio'].indexOf(record.name.toLowerCase()) === -1) {
                  return <div key={record.ident}>
                    <h5>{record.name}</h5>
                    <p>
                      {record.unit.location === 'before' && record.unit.symbol}
                      {typeof record.value === 'number' && record.value.toFixed(2)}
                      {record.unit.location === 'after' && record.unit.symbol}
                    </p>
                  </div>
                }
              })}
            </div>
            {(store.pnl.loading || store.price.loading || store.indicators.loading)
              ? <Spin>
                <div styleName='spin-filler'/>
              </Spin>
              : store.singleTicker.length && this.props.activeTab === store.ticker && Object.keys(store.indicators.list).length
                ? <Chart
                  priceTicker={store.price.ticker}
                  pnlFailed={store.pnl.failed}
                  priceFailed={store.price.failed}
                  indicatorsFailed={store.indicators.failed}
                  indicatorsList={store.indicators.list}
                  units={store.indicators.units}
                  consts={store.indicators.consts}
                  data={store.singleTicker.slice()}
                  timeFormat={store.labelFormat}
                  style={{margin:'20px 0'}}
                />
                : null
            }
          </div>
        }
      </div>
    )
  }
}

export default TickerDetails
